import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute from "../../../componant/authentication/ProtectedRoute";
import { ADMIN_ROLES } from "../../../utils/adminSession";
import AppControls from "../appControls/AppControls";
import CoinTransactions from "../coinTransaction/CoinTransaction";
import AddContest from "../contestControl/AddContest";
import ContestUsers from "../contestControl/ContestUsers";
import EditContest from "../contestControl/EditContest";
import ContestJoinUser from "../contestControl/JoinUser";
import ViewContestResult from "../contestControl/ViewContestResult";
import ViewContest from "../contestControl/ViewContest";
import NewCreateCourse from "../courseControl/NewCreateCourse";
import EditCourses from "../courseControl/EditCourse";
import ViewCourse from "../courseControl/ViewCourse";
import AddExam from "../exam/AddExam";
import LeaderBoard from "../leaderBoard/LeaderBoard";
import CreateLecture from "../lectureControl/CreateLecture";
import MockTestQuestions from "../mockTest/MockTestQuestions";
import MockTestResults from "../mockTest/MockTestResults";
import MockTests from "../mockTest/MockTests";
import PaymentSetting from "../payment/paymentSetting";
import RechargeOrders from "../payment/RechargeOrders";
import UpiOrders from "../payment/UpiOrders";
import AddQuestion from "../questionControl/AddQuestion";
import ContAddQ from "../questionControl/ContestAddQ";
import ContestEditQ from "../questionControl/ContestEditQ";
import ContestViewQ from "../questionControl/ContestViewQ";
import EditQuestion from "../questionControl/EditQuestion";
import ViewQuestion from "../questionControl/ViewQuestion";
import ReferralConfig from "../referralControl/ReferralConfig";
import ReferralDashboard from "../referralControl/ReferralDashboard";
import ReferralList from "../referralControl/ReferralList";
import ReferralPartner from "../referralControl/ReferralPartner";
import ReferralUserList from "../referralControl/referralUserList";
import AdminManagement from "../superAdmin/AdminManagement";
import InstituteWithdrawalRequests from "../superAdmin/InstituteWithdrawalRequests";
import InstitutePayments from "../superAdmin/InstitutePayments";
import FeatureManagement from "../superAdmin/FeatureManagement";
import DashHome from "../userPanal/dashhome/DashHome";
import ActiveUser from "../userControl/ActiveUser";
import DailyUser from "../userControl/DailyUser";
import KYCUser from "../userControl/KycUser";
import OnHoldUser from "../userControl/OnHoldUser";
import UserEdit from "../userControl/UserEdit";
import ViewUser from "../userControl/ViewUser";
import UnifiedWithdrawals from "../wallet/UnifiedWithdrawals";
import WhiteLabelAdmin from "../superAdmin/WhiteLabelAdmin";

const DashRoute = () => {
  return (
    <Routes>
      <Route path="/home" element={<DashHome />} />
      <Route path="/leader-board" element={<LeaderBoard />} />
      <Route path="/daily-user" element={<DailyUser />} />
      <Route path="/active-user" element={<ActiveUser />} />
      <Route path="/onHold-user" element={<OnHoldUser />} />
      <Route path="/KYC-user" element={<KYCUser />} />
      <Route path="/view-user/:id" element={<ViewUser />} />
      <Route path="/edit-user/:id" element={<UserEdit />} />
      <Route path="/view-course" element={<ViewCourse />} />
      <Route path="/create-course" element={<NewCreateCourse />} />
      <Route path="/create-lecture" element={<CreateLecture />} />
      <Route path="/edit-course/:id" element={<EditCourses />} />
      <Route path="/add-question/:id" element={<AddQuestion />} />
      <Route path="/view-question/:id" element={<ViewQuestion />} />
      <Route path="/edit-question/:id" element={<EditQuestion />} />
      <Route path="/add-contest" element={<AddContest />} />
      <Route path="/view-contest" element={<ViewContest />} />
      <Route path="/edit-contest/:id" element={<EditContest />} />
      <Route path="/addcontest-question/:id" element={<ContAddQ />} />
      <Route path="/viewcontest-question/:id" element={<ContestViewQ />} />
      <Route path="/editcontest-question/:id" element={<ContestEditQ />} />
      <Route path="/viewcontest-result/:id" element={<ViewContestResult />} />
      <Route path="/contest-users" element={<ContestUsers />} />
      <Route path="/join-user/:id" element={<ContestJoinUser />} />
      <Route path="/payment-setting" element={<PaymentSetting />} />
      <Route path="/upi-orders" element={<UpiOrders />} />
      <Route path="/recharge-orders" element={<RechargeOrders />} />
      <Route path="/unified-withdrawals" element={<UnifiedWithdrawals />} />
      <Route path="/referral-dashboard" element={<ReferralDashboard />} />
      <Route path="/referral-list" element={<ReferralList />} />
      <Route path="/all-users-referral" element={<ReferralUserList />} />
      <Route path="/referral-partner" element={<ReferralPartner />} />
      <Route path="/referral-config" element={<ReferralConfig />} />
      <Route path="/app-controls" element={<AppControls />} />
      <Route path="/addExam" element={<AddExam />} />
      <Route path="/mock-tests" element={<MockTests />} />
      <Route path="/mock-tests/:mockTestId/leaderboard" element={<MockTestResults />} />
      <Route path="/mock-tests/:mockTestId/results" element={<MockTestResults />} />
      <Route path="/mock-tests/:courseId" element={<MockTests />} />
      <Route
        path="/mock-tests/:courseId/questions/:mockTestId"
        element={<MockTestQuestions />}
      />
      <Route path="/coin-transaction" element={<CoinTransactions />} />
      <Route
        path="/institute-payments"
        element={(
          <ProtectedRoute allowedRoles={[ADMIN_ROLES.SUPER_ADMIN, ADMIN_ROLES.ADMIN]}>
            <InstitutePayments />
          </ProtectedRoute>
        )}
      />
      <Route
        path="/institute-withdrawal-requests"
        element={(
          <ProtectedRoute
            allowedRoles={[ADMIN_ROLES.SUPER_ADMIN, ADMIN_ROLES.ADMIN]}
          >
            <InstituteWithdrawalRequests />
          </ProtectedRoute>
        )}
      />
      <Route
        path="/admin-management"
        element={(
          <ProtectedRoute
            allowedRoles={[ADMIN_ROLES.SUPER_ADMIN, ADMIN_ROLES.ADMIN]}
          >
            <AdminManagement />
          </ProtectedRoute>
        )}
      />
      <Route
        path="/whiteLabel-admin-management"
        element={(
          <ProtectedRoute
            allowedRoles={[ADMIN_ROLES.SUPER_ADMIN, ADMIN_ROLES.ADMIN]}
          >
            <WhiteLabelAdmin />
          </ProtectedRoute>
        )}
      />
      <Route
        path="/feature-management"
        element={(
          <ProtectedRoute
            allowedRoles={[ADMIN_ROLES.SUPER_ADMIN, ADMIN_ROLES.ADMIN]}
          >
            <FeatureManagement />
          </ProtectedRoute>
        )}
      />
      <Route path="*" element={<Navigate to="/dash/home" replace />} />
    </Routes>
  );
};

export default DashRoute;
